import { Toast, ToastContainer } from 'react-bootstrap'
import '../styles.css'
import { IToast, ToastEnum } from '../../model/naglog/IToast'

export default function ToastComponent(props: IToast) {

  const getIcon = () => {
    let element
    switch (props.type) {
      case ToastEnum.DANGER:
      case ToastEnum.ERROR:
        element = <span className='text-danger'><i className='bi bi-radioactive'></i></span>
        break
      case ToastEnum.WARNING:
        element = <span className='text-warning'><i className='bi-exclamation-triangle'></i></span>
        break
      case ToastEnum.INFO:
        element = <span className='text-info'><i className='bi bi-info-circle'></i></span>
        break
      case ToastEnum.SUCCESS:
        element = <span className='text-success'><i className='bi bi-check-circle'></i></span>
        break
      default:
        break
    }

    return element
  }


  return (
    <div className=''>
      <ToastContainer position={props.position} className='main-content' style={{ zIndex: 1, position: 'fixed' }}>
        <Toast onClose={props.handleClose} show={props.isShow} className='bg-light rounded' delay={3000} autohide>
          <Toast.Header>
            <div className='fs-6'>
              {getIcon()}
            </div>
            <strong className='me-auto ms-2'>{props.title}</strong>
          </Toast.Header>
          <Toast.Body>
            {props.body}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  )
}
